import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/authContext";
import { formatLoginError } from "../utils";

/**
 * Hook personalizado para manejar la lógica del login
 */
export const useLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ email: "", password: "" });

  /**
   * Maneja cambios en los inputs del formulario
   */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  /**
   * Procesa el intento de login
   */
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const user = await login(form.email, form.password);
      navigate(user?.role === "technician" ? "/agenda" : "/");
    } catch (err) {
      const errorMessage = formatLoginError(err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    loading,
    error,
    handleChange,
    handleLogin,
  };
};

